import './About.css'

export default function About() {
    return (
        <div className="about-page">
            <div className="container">
                {/* Hero */}
                <section className="about-hero">
                    <h1>About SecondWorld</h1>
                    <p className="lead">
                        We're on a mission to provide premium products that elevate corporate
                        environments and empower businesses to succeed.
                    </p>
                </section>

                {/* Story */}
                <section className="about-section">
                    <div className="about-grid">
                        <div className="about-content">
                            <h2>Our Story</h2>
                            <p>
                                Founded with a vision to bridge the gap between quality and accessibility,
                                SecondWorld has grown from a small startup into a trusted partner for
                                businesses worldwide.
                            </p>
                            <p>
                                Our commitment to excellence drives everything we do – from carefully
                                curating our product selection to ensuring every customer receives
                                outstanding service.
                            </p>
                        </div>
                        <div className="about-image">
                            <div className="image-placeholder">🏢</div>
                        </div>
                    </div>
                </section>

                {/* Values */}
                <section className="about-section values-section">
                    <h2 className="text-center">Our Values</h2>
                    <div className="values-grid">
                        <div className="value-card">
                            <div className="value-icon">🎯</div>
                            <h3>Quality First</h3>
                            <p>Every product is carefully vetted to meet our high standards.</p>
                        </div>
                        <div className="value-card">
                            <div className="value-icon">🤝</div>
                            <h3>Customer Focus</h3>
                            <p>Your satisfaction is our top priority in everything we do.</p>
                        </div>
                        <div className="value-card">
                            <div className="value-icon">🌱</div>
                            <h3>Sustainability</h3>
                            <p>Committed to responsible practices and environmental care.</p>
                        </div>
                        <div className="value-card">
                            <div className="value-icon">💡</div>
                            <h3>Innovation</h3>
                            <p>Constantly improving to serve you better every day.</p>
                        </div>
                    </div>
                </section>

                {/* Stats */}
                <section className="about-section stats-section">
                    <div className="stats-grid">
                        <div className="stat">
                            <div className="stat-number">10K+</div>
                            <div className="stat-label">Happy Customers</div>
                        </div>
                        <div className="stat">
                            <div className="stat-number">500+</div>
                            <div className="stat-label">Products</div>
                        </div>
                        <div className="stat">
                            <div className="stat-number">50+</div>
                            <div className="stat-label">Countries</div>
                        </div>
                        <div className="stat">
                            <div className="stat-number">99%</div>
                            <div className="stat-label">Satisfaction</div>
                        </div>
                    </div>
                </section>
            </div>
        </div>
    )
}
